<vw-toast-popup [isOpen]="isOpen" [title]="'profile.infos.language' | translate" (close)="onClose()">
  <div class="px-4 pb-4">
    <!-- Chaque langue sous son propre nom, prononcé dans sa langue (`lang`). -->
    <vw-list-section [attr.aria-busy]="saving ? 'true' : null">
      @for (language of languages; track language) {
        <vw-list-row
          [attr.lang]="language.toLowerCase()"
          [title]="names[language]"
          [chevron]="false"
          [checked]="language === checked"
          (rowClick)="choose(language)"
        />
      }
    </vw-list-section>

    @if (error) {
      <p class="mt-3 text-body-s text-vw-danger" role="alert">
        {{ 'errors.businessException' | translate }}
      </p>
    }
  </div>
</vw-toast-popup>
